import type { HTMLAttributes, ReactNode } from "react";
import { classNames } from "../utils/classNames";

export type InlineErrorProps = Omit<HTMLAttributes<HTMLDivElement>, "title"> & {
  title?: ReactNode;
  message: ReactNode;
  errorCode?: string;
  action?: ReactNode;
};

export function InlineError({
  action,
  className,
  errorCode,
  message,
  title = "操作失败",
  ...props
}: InlineErrorProps) {
  return (
    <div {...props} role="alert" className={classNames("herskin-inline-error", className)}>
      <div className="herskin-inline-error__body">
        <div className="herskin-inline-error__title">{title}</div>
        <div className="herskin-inline-error__message">{message}</div>
        {errorCode ? <code className="herskin-inline-error__code">错误码：{errorCode}</code> : null}
      </div>
      {action ? <div className="herskin-inline-error__action">{action}</div> : null}
    </div>
  );
}
